import { useState } from 'react';

type FaqItem = {
  q: string;
  a: string;
};

type Props = {
  items: FaqItem[];
};

export default function FaqAccordion({ items }: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="w-full flex items-center justify-between gap-4 py-5 text-left"
              >
                <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {item.q}
                </span>
                <span
                  className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-lg transition-colors ${
                    isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-700'
                  }`}
                >
                  <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="pb-6 pr-10">
                <p className="text-sm md:text-base text-foreground-600 leading-7">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}